import { isTypeEmbedSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulEmbedSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeEmbedSection(entry)) {
    return null;
  }

  return <div>ContentfulEmbedSection</div>;
};

export default ContentfulEmbedSection;
